var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-red-500 p-6 mb-6 fixed w-full"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('h1',{staticClass:"font-bold uppercase"},[_vm._v("🌍 Covid-19 Stats")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }